<div class="row">
  <div class="col col-auto">

    <ng-container *ngIf="isNew">
      <button class="btn-painel outline language-item small selected" type="button" mat-button *ngFor="let item of getOnlyEnglish()">
        <span ngClass="flag-icon flag-icon-{{ item.flag }}"></span>
        <span>{{item.name}}</span>
      </button>
    </ng-container>


    <ng-container *ngIf="!isNew">
      <button class="btn-painel outline language-item small" *ngFor="let item of translatedLanguages" [ngClass]="{'selected': item.code === editingLanguage}" type="button" mat-button (click)="editLanguage(item.code)">
        <span ngClass="flag-icon flag-icon-{{ item.flag }}"></span>
        <span>{{item.name}}</span>
      </button>

      <button class="btn-painel outline language-item small" type="button" mat-button [matMenuTriggerFor]="menu" *ngIf="!isNew && availableLanguages.length > 0">
        <i class="material-icons">add</i>
        <span [translate]="'painel-dashboard/add-language'"></span>
      </button>

      <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
        <button mat-menu-item class="language-item menu" *ngFor="let item of availableLanguages" (click)="addLanguage(item)">
          <span ngClass="flag-icon flag-icon-{{ item.flag }}"></span>
          <span>{{item.name}}</span>
        </button>
      </mat-menu>
    </ng-container>
  </div>